import 'bootstrap'
import tile from './legacy/v1/tiles.js'
// import icon from './legacy/v1/icon.js' (see components/icons.ts)
import newsteaser from './legacy/v1/newsteaser.js'
import footer from './legacy/v1/footer.js'
import eventOverview from './legacy/v1/event-overview.js'
import linkDownloadList from './legacy/v1/link-download-list.js'
import newsOverview from './legacy/v1/news-overview.js'
// import factoringtest from './legacy/v1/factoringtest.js' (see components/factoringtest.ts)
// import leasingtest from './legacy/v1/leasingtest.js' (see components/leasingtest.ts)
import stickyNavigation from './legacy/v1/sticky-navigation.js'
// import accordion from './legacy/v1/accordion.js' (see components/accordion.ts)
import corporateFacts from './legacy/v1/corporate-facts.js'
import animateInputPlaceholder from './legacy/v1/animate-input-placeholder.js'
import contactDetail from './legacy/v1/contact-detail.js'
import contactDropdown from './legacy/v1/contact-dropdown.js'
import locationFinderLoader from './legacy/v1/location-finder-loader.js'
import comparisonTable from './legacy/v1/comparison-table.js'
import solutionFinder from './legacy/v1/solution-finder.js'
import suggestion from './legacy/v1/suggestion.js'
import optout from './legacy/v1/optout.js'
import teamwall from './legacy/v1/teamwall.js'
import glossary from './legacy/v1/glossary.js'
import calculator from './legacy/v1/campaign/fgs/calculator.js'
import eloquaForm from './legacy/v1/eloqua-form.js'
import cashflowOptimizerCalculator from './legacy/v1/cashflow-optimizer-calculator.js'
import leasingCalculator from './legacy/v1/leasing-calculator/leasing-calculator.js'
import internationalLeasingCalculator
  from './legacy/v1/international-leasing-calculator/international-leasing-calculator.js'
import dataProtection from './legacy/v1/data-protection.js'
import contactTeaser from './legacy/v1/contact-teaser.js'
// youtubeIframe migrated to component-loader (see components/youtube-video.ts)
// videoModals removed: Bootstrap's data-api (data-toggle/data-target) opens these modals
import { updateSessionStorage } from './legacy/v1/updateSessionStorage.js'
import diagrams from './legacy/v1/diagrams.js'
import kpis from './legacy/v1/kpis.js'
// Eloqua Form With Layout is initialized lazily through integrations/integration-loader.ts.
import focuspoints from './legacy/v1/focuspoint.js'
// import colorBox from './legacy/v1/color-box.js'
import tracking from './legacy/v1/tracking.js'

// --- GLOBAL APP NAMESPACE ---
window.app = window.app || {}

// --- Component callback registry ---
const componentRefreshCallbacks = {}

// Global Callback for component refresh
// This is utilized if a component gets added dynamically (for example: Experience Manager)
window.app.registerComponentRefreshCallback = (componentName, callback) => {
  if (typeof callback === 'function') {
    componentRefreshCallbacks[componentName] = callback
  }
}

async function initializeApplication () {
  const btn = document.getElementById('btn-history-back')
  if (btn) btn.addEventListener('click', () => window.history.back())

  // Beispiel: Textwrapping
  document.querySelectorAll('.bullets li').forEach(li => {
    const html = li.innerHTML
    li.textContent = ''
    const span = document.createElement('span')
    span.className = 'text-wrap'
    span.innerHTML = html
    li.appendChild(span)
  })

  // Infinite scrolling handler
  document.addEventListener('infiniteScrolling', () => {
    document.querySelectorAll('.img-fill .hide-while-load').forEach(el => {
      el.classList.remove('hide-while-load')
    })
    document.querySelectorAll('.bullets li').forEach(li => {
      const text = li.textContent
      li.textContent = ''
      const span = document.createElement('span')
      span.className = 'text-wrap'
      span.textContent = text
      li.appendChild(span)
    })
    newsteaser?.init?.()
  })

  // Hide loader overlays
  document.querySelectorAll('.hide-while-load').forEach(el => el.classList.remove('hide-while-load'))

  // Handle OneTrust updates
  window.addEventListener('OneTrustGroupsUpdated', () => {
    updateSessionStorage()
    contactDetail.init()
    eloquaForm.init()
  })

  // Handle Bloomreach component refresh
  window.addEventListener('component-edit-refresh', e => {
    const name = e.detail?.componentName
    if (name && componentRefreshCallbacks[name]) {
      console.log(`🔁 Refreshing component: ${name}`)
      componentRefreshCallbacks[name](e.detail?.sectionElement)
    }
  })
}

// --- Component initialization ---
async function initializeComponents () {
  const components = [
    // assetSlider - migrated to component-loader
    footer,
    // icon - migrated to component-loader
    tile,
    newsteaser,
    // portfolio - migrated to component-loader
    // storytelling - migrated to component-loader
    // inpageNavigation - migrated to scrollable-nav integration
    eventOverview,
    animateInputPlaceholder,
    linkDownloadList,
    newsOverview,
    // tabTextImage - migrated to component-loader
    // factoringtest - migrated to component-loader
    // leasingtest - migrated to component-loader
    stickyNavigation,
    // accordion - migrated to component-loader
    corporateFacts,
    contactDetail,
    contactDropdown,
    locationFinderLoader,
    comparisonTable,
    solutionFinder,
    suggestion,
    optout,
    teamwall,
    glossary,
    dataProtection,
    contactTeaser,
    calculator,
    eloquaForm,
    // tabsearch - migrated to component-loader
    cashflowOptimizerCalculator,
    internationalLeasingCalculator,
    leasingCalculator,
    diagrams,
    kpis,
    // eloquaFormValidation,
    focuspoints,
    // colorBox,
    tracking
  ]
  for (const component of components) {
    await component.init(window.app.registerComponentRefreshCallback)
  }
}

// --- Initialization on DOM ready ---
document.addEventListener('DOMContentLoaded', async () => {
  // console.log('🚀 DOMContentLoaded – Initialisierung startet')
  await initializeApplication()
  await initializeComponents()
})
